import React from 'react';
import { OverlayTrigger, Popover, PopoverContent } from 'react-bootstrap';

const OverLayWrapper = ({
  placement = 'right',
  trigger = ['hover', 'focus'],
  popoverStyle = { minWidth: '12rem' },
  popoverContent,
  show = true,
  rootClose = false,
  children,
  onHide,
  controlledShow,
}) => {
  const isControlled = onHide !== undefined && controlledShow !== undefined;

  if (!show && !isControlled) {
    return children;
  }

  return (
    <OverlayTrigger
      placement={placement}
      trigger={isControlled ? [] : trigger}
      rootClose={rootClose}
      show={isControlled ? controlledShow : undefined}
      onHide={isControlled ? onHide : undefined}
      overlay={
        <Popover style={popoverStyle}>
          <PopoverContent>{popoverContent}</PopoverContent>
        </Popover>
      }
    >
      {children}
    </OverlayTrigger>
  );
};

export default OverLayWrapper;
